import { IconEye, IconEyeClose } from '@/assets/icons';
import { Button, InputText } from '@/components';
import { classNames } from '@/helpers/common';
import React, { FormEvent } from 'react';
import { UseFormReturn } from 'src/hooks';
import logoFull from '../../../../assets/images/logo-full-white.png';
import { FormInputNameLogin, ShouldShowModal, ShouldShowModalProps } from '../types';

interface StateProps extends Pick<UseFormReturn, 'formData' | 'formErrors' | 'onChangeFormInput'> {
  state: boolean;
  enableLoginPassword: boolean;
  shouldShowPasswordToText: boolean;
  // shouldShowPasswordToText2: boolean;
}

interface DispathProps {
  onTogglePasswordToText: () => void;
  onCheckCPF: () => void;
  onSubmit: (e: FormEvent) => void;
  onShouldShowModal: ({ value, newTitle }: ShouldShowModalProps) => void;
}

type LoginContentProps = StateProps & DispathProps;

export const LoginContent: React.FC<LoginContentProps> = ({
  state,
  shouldShowPasswordToText,
  formData,
  formErrors,
  enableLoginPassword,
  onChangeFormInput,
  onCheckCPF,
  onSubmit,
  onTogglePasswordToText,
  onShouldShowModal,
}) => (
  <div>
    <div className="flex flex-col justify-center items-center">
      <img className="w-auto h-[160px]" src={logoFull} alt="Banca do Ingresso" />
    </div>

    <div className="w-full">
      <form onSubmit={onSubmit}>
        <div className="mb-[15px]">
          <InputText
            name="document"
            label="CPF"
            placeholder="123.456.789-00"
            className={`appearance-none w-full
                rounded-md text-heading leading-tight focus:outline-none
                focus:shadow-outline text-xs font-dmsans font-normal`}
            maxLength={14}
            value={formData[FormInputNameLogin.document]}
            onChange={e => onChangeFormInput(FormInputNameLogin.document)(e.target.value)}
            onBlur={() => onCheckCPF()}
            error={formErrors.document && formErrors.document[0]}
          />
        </div>

        <div className="mb-0">
          <InputText
            id="loginPWD"
            name="password"
            label="Senha"
            disabled={!enableLoginPassword}
            type={shouldShowPasswordToText ? 'text' : 'password'}
            placeholder="**********"
            value={formData[FormInputNameLogin.password]}
            maxLength={15}
            onChange={e => onChangeFormInput(FormInputNameLogin.password)(e.target.value)}
            error={formErrors.password && formErrors.password[0]}
            renderForward={
              <button
                className={classNames(
                  formErrors.password && formErrors.password[0]
                    ? 'right-0 bottom-7'
                    : 'right-0 bottom-3',
                  'absolute cursor-pointer mr-4',
                )}
                onClick={onTogglePasswordToText}
                type="button"
              >
                <div className="h-8 flex flex-col justify-center items-center">
                  {shouldShowPasswordToText ? (
                    <img src={IconEye} alt="Mostrar senha" />
                  ) : (
                    <img src={IconEyeClose} alt="Ocultar senha" />
                  )}
                </div>
              </button>
            }
          />
        </div>
        <div className="flex flex-col items-start justify-between">
          <a
            className="mb-[20px] mt-4 underline underline-offset-2 inline-block
              align-baseline text-[#1B4880] text-base font-bold font-dmsans"
            href="#"
            onClick={() =>
              onShouldShowModal({
                value: ShouldShowModal.FORGOT_PASSWORD,
                newTitle: 'Esqueceu a sua senha?',
              })
            }
          >
            Esqueci minha senha?
          </a>
          <Button
            type="submit"
            title="Entrar"
            buttonStyle="primary"
            size="xlg"
            className="w-full"
            disabled={
              formData[FormInputNameLogin.document] === '' ||
              formData[FormInputNameLogin.password] === '' ||
              state
            }
          />
        </div>
        <div className="flex items-baseline justify-center">
          <button
            id="btnDoLogin"
            className={classNames(
              'w-full mt-3 px-10 py-4 transition-colors duration-150 text-bold rounded-lg focus:shadow-outline bg-[#0587c4] hover:bg-[#056b9f] active:bg-neutro-b-400 text-base font-bold font-dmsans text-white',
            )}
            onClick={() =>
              onShouldShowModal({
                value: ShouldShowModal.CHECK_ACCOUNT_CONTENT,
                newTitle: 'Informe seu CPF',
              })
            }
          >
            Criar Conta
          </button>
        </div>
      </form>
    </div>
  </div>
);
